import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Grid, Message } from 'semantic-ui-react';
//noinspection NpmUsedModulesInstalled
import { Icon } from '@plone/volto/components';
//noinspection NpmUsedModulesInstalled
import downloadSVG from '@plone/volto/icons/download.svg';
import DownloadItem from './DownloadItem';

const messages = defineMessages({
  trans_choose_source: {
    id: 'trans_choose_source',
    defaultMessage: 'Please select media content.',
  },
});

const DownloadItems = ({ data, isEditMode, intl }) => {
  return (
    <>
      {!data?.download ? (
        <Message>
          <div className="download-block default">
            <Icon name={downloadSVG} />
            <div>
              <span>{intl.formatMessage(messages.trans_choose_source)}</span>
            </div>
          </div>
        </Message>
      ) : (
        <div className="download-block">
          <Grid padded textAlign="center" verticalAlign="middle">
            {data.download.map(function (item, i) {
              if (!isEditMode) {
                return <DownloadItem data={item} key={i} />;
              } else {
                return <DownloadItem data={item} key={i} isEditMode />;
              }
            })}
          </Grid>
        </div>
      )}
    </>
  );
};

export default injectIntl(DownloadItems);
